import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsBooleanHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Boolean;
    }
}

//# sourceMappingURL=IsBooleanHelper.js.map
